import React, { useState } from "react";
import "./Contact.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const response = await fetch("http://localhost:5000/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("Message sent successfully ✅");
        setFormData({
          name: "",
          phone: "",
          email: "",
          subject: "",
          message: "",
        });
      } else {
        setStatus("Something went wrong ❌");
      }
    } catch (error) {
      console.error(error);
      setStatus("Network error ❌");
    }
  };

  return (
    <div className="contact-page">
      {/* Video + Form Overlay */}
      <div className="video-section">
        <video autoPlay loop muted playsInline className="bg-video">
          <source src="/assets/cvid.mp4" type="video/mp4" />
          Your browser does not support video playback.
        </video>

        <div className="contact-overlay">
          <h3 className="contact-title">Contact Us</h3>
          <p className="contact-sub">
            Need help? Fill the form and we'll get back to you.
          </p>

          <form onSubmit={handleSubmit} className="contact-form">
            <div className="row">
              <div className="col">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name*"
                  required
                />
              </div>
              <div className="col">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone"
                />
              </div>
            </div>

            <div className="row">
              <div className="col">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email*"
                  required
                />
              </div>
              <div className="col">
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                />
              </div>
            </div>

            <div className="row">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message*"
                rows="5"
                required
              ></textarea>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-submit">
                Submit
              </button>
              <span className="form-status">{status}</span>
            </div>
          </form>
        </div>
      </div>

      {/* Map */}
      <div className="map-container">
        <iframe
          title="India Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d48860606.46865854!2d68.17664587374174!3d22.19929609086976!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30635ff3f79fd6d3%3A0x6c3c0f86beba4d71!2sIndia!5e0!3m2!1sen!2sin!4v1695123456789"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default ContactPage;
